
import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
} from "react-router-dom";


const BookingNavbarHero = ({
  property,
}) => {

  /* =========================================================
     SCROLL STATE
  ========================================================= */

  const [
    isScrolled,
    setIsScrolled,
  ] = useState(false);


  /* =========================================================
     SCROLL LISTENER
  ========================================================= */

  useEffect(() => {

    const handleScroll = () => {

      setIsScrolled(
        window.scrollY > 30
      );

    };


    window.addEventListener(
      "scroll",
      handleScroll,
      {
        passive: true,
      }
    );


    handleScroll();


    return () => {

      window.removeEventListener(
        "scroll",
        handleScroll
      );

    };

  }, []);


  /* =========================================================
     SCROLL TO ROOMS
  ========================================================= */

  const scrollToRooms = () => {

    document
      .getElementById("rooms")
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

  };


  /* =========================================================
     BUILD PROPERTY IMAGE URL
     
     API RETURNS:
     
     hotelLogo:
     /uploads/profile/1788240062043-149419795.jpg
     
     subdomain:
     nexifysolutionyatran
     
     FINAL URL:
     
     https://nexifysolutionyatran.yatranest.in/uploads/profile/1788240062043-149419795.jpg
  ========================================================= */

  const getImageUrl = (
    imagePath
  ) => {

    if (!imagePath) {
      return "";
    }


    /* =======================================================
       IF API ALREADY RETURNS FULL URL
    ======================================================= */

    if (
      imagePath.startsWith(
        "http://"
      ) ||
      imagePath.startsWith(
        "https://"
      )
    ) {

      return imagePath;

    }


    /* =======================================================
       PROPERTY SUBDOMAIN
       
       Prefer property.subdomain because this comes directly
       from the public booking-engine property API.
    ======================================================= */

    const subdomain =
      property?.subdomain;


    if (!subdomain) {

      console.warn(
        "⚠️ PROPERTY SUBDOMAIN NOT AVAILABLE FOR IMAGE:",
        property
      );

      return "";

    }


    /* =======================================================
       BUILD TENANT DOMAIN
    ======================================================= */

    const propertyDomain =
      `https://${subdomain}.yatranest.in`;


    /* =======================================================
       COMBINE DOMAIN + IMAGE PATH
    ======================================================= */

    return `${propertyDomain}${
      imagePath.startsWith("/")
        ? imagePath
        : `/${imagePath}`
    }`;

  };


  /* =========================================================
     HOTEL LOGO
  ========================================================= */

  const hotelLogoUrl =
    getImageUrl(
      property?.hotelLogo
    );


  /* =========================================================
     DEBUG
  ========================================================= */

  console.log(
    "🏨 BOOKING PROPERTY:",
    property
  );


  console.log(
    "🌐 PROPERTY SUBDOMAIN:",
    property?.subdomain
  );


  console.log(
    "🖼️ HOTEL LOGO PATH:",
    property?.hotelLogo
  );


  console.log(
    "🖼️ FINAL HOTEL LOGO URL:",
    hotelLogoUrl
  );


  /* =========================================================
     RENDER
  ========================================================= */

  return (

    <section className="be-hero-section">

      <div className="be-hero">


        {/* =====================================================
            HERO IMAGE
        ===================================================== */}

        <img
          src="https://images.pexels.com/photos/37146574/pexels-photo-37146574.jpeg"
          alt={
            property?.propertyName ||
            "Hotel"
          }
          className="be-hero-image"
        />


        {/* =====================================================
            OVERLAY
        ===================================================== */}

        <div className="be-hero-overlay" />


        {/* =====================================================
            NAVBAR
        ===================================================== */}

        <header
          className={[
            "be-navbar",
            isScrolled
              ? "be-navbar-scrolled"
              : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >


          {/* ===================================================
              HOTEL LOGO
          =================================================== */}

          <div className="be-logo">

            {
              hotelLogoUrl ? (

                <img
                  src={hotelLogoUrl}
                  alt={
                    property?.propertyName ||
                    "Hotel logo"
                  }
                  className="hotel-logo"

                  onError={(event) => {

                    console.error(
                      "❌ HOTEL LOGO FAILED TO LOAD:",
                      hotelLogoUrl
                    );

                    event.currentTarget.style.display =
                      "none";

                  }}
                />

              ) : (

                <div className="be-logo-placeholder">

                  {
                    property?.propertyName
                      ?.charAt(0)
                      ?.toUpperCase() ||
                    "H"
                  }

                </div>

              )
            }

          </div>


          {/* ===================================================
              NAVIGATION
          =================================================== */}

          <nav className="be-navigation">

            <a href="#rooms">
              Rooms
            </a>


            <Link to="/coming-soon">
              Food &amp; Beverages
            </Link>


            <Link to="/coming-soon">
              Cabs
            </Link>


            <a href="#contact">
              Contact
            </a>

          </nav>


          {/* ===================================================
              BOOK NOW
          =================================================== */}

          <button
            type="button"
            className="be-nav-book"
            onClick={scrollToRooms}
          >

            Book Now

          </button>

        </header>


        {/* =====================================================
            HERO CONTENT
        ===================================================== */}

        <div className="be-hero-content">

          <div className="be-hero-copy">

            <h3 className="be-hero-title">

              You’re One Click Away from Your Room

            </h3>


            <small className="white">

              Just the Essentials, Then You're Booked

            </small>


            <div className="be-hero-actions">


              {/* PRIMARY */}

              <button
                type="button"
                className="be-hero-primary"
                onClick={scrollToRooms}
              >

                <span>
                  Book your stay
                </span>


                <span className="be-hero-arrow">
                  →
                </span>

              </button>


              {/* SECONDARY */}

              <a
                href="#rooms"
                className="be-hero-secondary"
              >

                Explore rooms

              </a>

            </div>

          </div>

        </div>

      </div>

    </section>

  );

};


export default BookingNavbarHero;